/* RAJ design layer — behaviours. Vanilla, no dependencies. */
(function () {
  'use strict';

  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Product card: hover photo scrub ---------- */
  function initScrub(root) {
    (root || document).querySelectorAll('.raj-scrub:not([data-ready])').forEach(function (scrub) {
      scrub.setAttribute('data-ready', '1');
      if (!fine) return;
      var card = scrub.closest('.raj-card') || scrub.parentElement;
      var slides = scrub.querySelectorAll('.raj-scrub__slide');
      var dots = scrub.querySelectorAll('.raj-scrub__dots span');
      if (slides.length < 2) return;
      var current = 0;
      function go(i) {
        if (i === current) return;
        slides[current].classList.remove('is-on');
        if (dots[current]) dots[current].classList.remove('is-on');
        current = i;
        slides[current].classList.add('is-on');
        if (dots[current]) dots[current].classList.add('is-on');
      }
      card.addEventListener('mousemove', function (e) {
        var r = scrub.getBoundingClientRect();
        if (!r.width) return;
        var i = Math.floor(((e.clientX - r.left) / r.width) * slides.length);
        go(Math.max(0, Math.min(slides.length - 1, i)));
      });
      card.addEventListener('mouseleave', function () { go(0); });
    });
  }

  /* ---------- 'Saving 44%' chip -> '44% OFF' ----------
     Only the words around Minimog's [data-saving-value] span change. Minimog looks that span up when the
     product initialises and writes into it on every variant change; replacing the chip's text deleted it,
     so on cached page loads Minimog's product init crashed and the photo gallery never started. */
  function fixSaving() {
    document.querySelectorAll('.prod__tag-saving').forEach(function (el) {
      var v = el.querySelector('[data-saving-value]');
      if (!v) {
        var m = el.textContent.match(/(\d+)\s*%/);
        if (!m) return;
        var t = m[1] + '% OFF';
        if (el.textContent.trim() !== t) el.textContent = t;
        return;
      }
      [].slice.call(el.childNodes).forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = ''; });
      var off = v.nextElementSibling;
      if (!off || !off.hasAttribute('data-raj-off')) {
        off = document.createElement('span');
        off.setAttribute('data-raj-off', '');
        off.textContent = ' OFF';
        v.parentNode.insertBefore(off, v.nextSibling);
      }
    });
  }

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    document.querySelectorAll('.raj-ann[data-rotate]:not([data-ready])').forEach(function (bar) {
      bar.setAttribute('data-ready', '1');
      var items = bar.querySelectorAll('.raj-ann__item');
      if (items.length < 2) return;
      var i = 0, delay = parseInt(bar.dataset.rotate, 10) || 5000, timer;
      function show(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      function start() { timer = setInterval(function () { show(i + 1); }, delay); }
      start();
      bar.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { clearInterval(timer); show(i + parseInt(b.dataset.dir, 10)); start(); });
      });
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero() {
    document.querySelectorAll('.raj-hero[data-autoplay]:not([data-ready])').forEach(function (hero) {
      hero.setAttribute('data-ready', '1');
      var slides = hero.querySelectorAll('.raj-hero__slide');
      var dots = hero.querySelectorAll('.raj-hero__dots button');
      if (slides.length < 2) return;
      var i = 0, delay = parseInt(hero.dataset.autoplay, 10) || 0, timer;
      function go(n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      }
      function start() { if (delay > 0) timer = setInterval(function () { go(i + 1); }, delay); }
      function restart() { clearInterval(timer); start(); }
      start();
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); restart(); }); });
      hero.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { go(i + parseInt(b.dataset.dir, 10)); restart(); });
      });
      // touch swipe
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); }
      }, { passive: true });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs() {
    document.querySelectorAll('[data-raj-tabs]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var tabs = wrap.querySelectorAll('.raj-tab');
      var panels = wrap.querySelectorAll('.raj-panel');
      tabs.forEach(function (tab, n) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          panels.forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          if (panels[n]) panels[n].classList.add('is-active');
          initScrub(panels[n]);
          // Wake lazysizes for images inside the newly shown panel
          try { if (window.lazySizes && lazySizes.loader) lazySizes.loader.checkElems(); } catch (err) {}
          window.dispatchEvent(new Event('resize'));
        });
      });
    });
  }

  /* ---------- Scroll rows with arrows (+ optional auto-scroll) ---------- */
  function initRows() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-raj-row]:not([data-ready])').forEach(function (wrap) {
      wrap.setAttribute('data-ready', '1');
      var track = wrap.querySelector('[data-raj-track]');
      if (!track) return;
      function step() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
      }
      wrap.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () {
          track.scrollBy({ left: step() * parseInt(b.dataset.dir, 10), behavior: 'smooth' });
        });
      });
      var delay = parseInt(wrap.dataset.rajAutoplay, 10) || 0;
      if (!delay || reduce || track.children.length < 2) return;
      var hold = false, visible = false, resume;
      wrap.addEventListener('mouseenter', function () { hold = true; });
      wrap.addEventListener('mouseleave', function () { hold = false; });
      track.addEventListener('touchstart', function () { hold = true; clearTimeout(resume); }, { passive: true });
      track.addEventListener('touchend', function () { clearTimeout(resume); resume = setTimeout(function () { hold = false; }, 4000); }, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(track);
      } else { visible = true; }
      setInterval(function () {
        if (hold || !visible || document.hidden || !track.isConnected) return;
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 8) track.scrollTo({ left: 0, behavior: 'smooth' });
        else track.scrollBy({ left: step(), behavior: 'smooth' });
      }, delay);
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-raj-count]:not([data-ready])');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, target = parseFloat(el.dataset.rajCount) || 0, t0 = null;
        el.setAttribute('data-ready', '1');
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / 1400, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * e).toLocaleString('en-IN');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.raj-reveal:not([data-ready])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (el) { el.setAttribute('data-ready', '1'); io.observe(el); });
  }

  /* ---------- Reels: make sure videos play (and pause offscreen) ---------- */
  function initVideos() {
    var vids = document.querySelectorAll('.raj-ig video:not([data-ready])');
    if (!vids.length) return;
    var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.2 }) : null;
    vids.forEach(function (v) {
      v.setAttribute('data-ready', '1');
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if (io) io.observe(v); else { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }

  function init(root) {
    initScrub(root);
    initVideos();
    initAnnouncement();
    initHero();
    initTabs();
    initRows();
    initCounters();
    initReveal();
    fixSaving();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Re-init for ajax-loaded products (load more, recommendations, quick view, filters)
  var mo = new MutationObserver(function (muts) {
    var need = false;
    for (var k = 0; k < muts.length; k++) { if (muts[k].addedNodes.length) { need = true; break; } }
    if (need) { clearTimeout(mo._t); mo._t = setTimeout(function () { initScrub(); fixSaving(); }, 80); }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // Theme editor
  document.addEventListener('shopify:section:load', function () { init(); });
})();
